import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { store } from './features/store';
import { setStoreInstance } from './services/api';
import { appQueryClient } from './lib/queryClient';
import { ThemeProvider } from './components/theme/ThemeProvider';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { pruneOrphanedDrafts } from './hooks/useFormDraft';
import './index.css';

// [T246.5-FE-PAGE] Wrap the app tree with TanStack Query's QueryClientProvider
// so every component tree (including the new /widgets/insights page) can
// read from the shared QueryClient without re-provisioning one.

// Initialize store in api service to break circular dependency
setStoreInstance(store);

// [T73P3-a] Clean up stale draft keys on startup
pruneOrphanedDrafts();

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined;

const appTree = (
  <Provider store={store}>
    <QueryClientProvider client={appQueryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      {googleClientId
        ? <GoogleOAuthProvider clientId={googleClientId}>{appTree}</GoogleOAuthProvider>
        : appTree}
    </ErrorBoundary>
  </React.StrictMode>
);